import { $$, extend, addEvent } from './helper-functions'

export class TabsVariant1 {
  constructor (settings, selectors, classes) {
    this.settings = extend({
    }, settings)

    this.selectors = extend({
      tabs: '.tabs--variant-1',
      content: '.tabs__content',
      buttonOpenContent: '.tabs__navigation button'
    }, selectors)

    this.classes = extend({
      active: 'is--active'
    }, classes)

    this.$tabs = $$(this.selectors.tabs)
  }

  init () {
    this.addEvents()
  }

  addEvents () {
    this.$tabs.forEach(tab => {
      this.$buttonOpenContent = $$(this.selectors.buttonOpenContent, tab)

      this.$buttonOpenContent.forEach((buttonOpenContent, buttonIndex) => {
        addEvent(buttonOpenContent, 'click', () => {
          const tabsContent = $$(this.selectors.content, tab)

          tabsContent.forEach((tabContent, index) => {
            tabContent.classList.toggle(this.classes.active, buttonIndex === index)
          })

          this.$buttonOpenContent.forEach((otherButtonOpenContent, index) => {
            otherButtonOpenContent.classList.toggle(this.classes.active, buttonIndex === index)
          })
        })
      })
    })
  }
}

export default TabsVariant1
